export default __webpack_public_path__ + "static/media/icon-dragger.c36e7864.svg";